import { render } from "./VehiculosView.vue?vue&type=template&id=d04fc986"
import script from "./VehiculosView.vue?vue&type=script&lang=js"
export * from "./VehiculosView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__